const animations = document.querySelectorAll('.animation');
const observer = new IntersectionObserver(entries => {
    // Loop over the entries
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animation--done');
        }
    });
});

animations.forEach(sections => {
    observer.observe(sections);
});


document.addEventListener('DOMContentLoaded', function() {
    const link = document.querySelector('a[href="#more"]');
    if(link){
        link.addEventListener('click', function(event) {
            event.preventDefault();
            smoothScroll('#more');
        });
    }
});
